import React, { useState } from "react";
import moment from "moment"
export default function ProgressTracker(props) {
    const { request } = props;
console.log("requesr", request)
    const initialStatusOptions = [
        { name: "Order Received", disabled: true },
        { name: "Processing", disabled: true },
        { name: "Packed", disabled: true },
        { name: "Shipping", disabled: true },
        { name: "Delivered", disabled: true },
    ];
    const [closeDialog, setCloseDialog] = useState()
    const CloseDialog = () => {
        // console.log('deepak dolaf')
        props.fucn()
    }


    return (
        <>
            <div class="dialogHeader">
                <h3> Order Status and progress tracking</h3>
                <button onClick={CloseDialog}>
                    <i class="fa-regular fa-xmark">
                    </i>
                </button>
            </div>

            <div className="printbox">

                <table className="trackertable">
                    <tr>
                    <th>{request?.nft_id?.name}</th>
                        <td rowSpan={2}>$ {request?.total_cost} </td>

                    </tr>
                    <tr>
                        {/* <th className="progresqty">Quantity - 1</th> */}

                    </tr>
                </table>

                <div className="progbar">

                    <ul>
                        {initialStatusOptions?.map((item, ind) =>
                            <li className={request?.order_tracking_status.some((item2) => item2.status === item?.name) ? "active" : ""}>
                                <div className="innerlist">
                                <img class={`${request?.order_tracking_status.some((item2) => item2.status === item?.name) ? "checkimg active" : "checkimg"}`} alt="" src="../../images/svg/check-mark.svg" />
                                <div className="progcontent"><h5> {item?.name}</h5>
                                    {/* <p>7 Aug 2024</p> */}
                                    <p>{request?.order_tracking_status[ind] && moment(request?.order_tracking_status.find((item2) => item2.status === item?.name)?.date)?.utcOffset(330).format("DD MMM YYYY")    }</p>
                                  
                                    </div>
                            </div>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="currStatus">
                    <p>Current Status</p>
                    <button className="statusbtn">{request?.order_tracking_status[request?.order_tracking_status.length-1]?.status}</button>
                </div>
            </div>

        </>
    );




}